var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyClipboard = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M9.794 16.973q-.684 0-1.159-.454a1.48 1.48 0 0 1-.474-1.11V5.564q0-.654.474-1.109A1.61 1.61 0 0 1 9.794 4h7.573q.684 0 1.159.454.474.454.474 1.11v9.846q0 .655-.474 1.109a1.61 1.61 0 0 1-1.159.454zm0-1.297h7.573q.105 0 .191-.083a.25.25 0 0 0 .087-.183V5.563a.25.25 0 0 0-.087-.183.27.27 0 0 0-.19-.083H9.793a.27.27 0 0 0-.191.083.25.25 0 0 0-.087.183v9.847a.25.25 0 0 0 .087.183.27.27 0 0 0 .191.083M6.633 20q-.684 0-1.159-.454A1.48 1.48 0 0 1 5 18.436V7.294h1.355v11.144a.25.25 0 0 0 .087.183.27.27 0 0 0 .19.083h8.929V20z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyClipboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy-clipboard.589d04dc.svg";